<template>
  <div
    v-if="results"
    class="h-full"
  >
    <ApexChart
      height="100%"
      :options="chartConfig"
      :series="chartSeries"
    />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import ApexChart from 'vue3-apexcharts'

import { shadeColor } from '@/lib/color'
// import { formatSpaceUnit } from '@/lib/spaceUnit'
import dateMixin from '@/lib/date'
import brandingMixin from '@/mixins/branding'
import currencyMixin from '@/mixins/currency'

const LOCALE_CONFIG = {
  de: {
    name: 'de',
    options: {
      shortMonths: [
        'Jan',
        'Feb',
        'Mär',
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez',
      ],
    },
  },
  en: {
    name: 'en',
    options: {
      shortMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
    },
  },
}

export default {
  components: { ApexChart },
  mixins: [currencyMixin, dateMixin, brandingMixin],
  props: {
    results: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { locale } = useI18n()

    return { locale }
  },

  computed: {
    chartConfig() {
      return {
        chart: {
          locales: [LOCALE_CONFIG.de, LOCALE_CONFIG.en],
          defaultLocale: LOCALE_CONFIG[this.locale] ? this.locale : 'en',
          type: 'area',
          parentHeightOffset: 0,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 0,
        },
        fill: {
          opacity: 1,
          type: 'solid',
        },
        legend: {
          show: true,
          position: 'top',
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false,
          },
          categories: this.results?.property?.valueTrend.map((item) => item.date).reverse(),
        },
        yaxis: {
          labels: {
            formatter: (val) => this.formatPrice(val),
          },
        },
        colors: [
          shadeColor(this.primaryColor, -80),
          shadeColor(this.primaryColor, 40),
          this.primaryColor,
        ],
      }
    },

    chartSeries() {
      if (!this.results) return []

      const series = []
      const { valueTrend } = this.results.property

      const extractSeries = (key, name) => {
        const data = valueTrend
          .map((item) => (key === 'value' ? item[key] : item.valueRange?.[key]))
          .reverse()

        if (data.some(Boolean)) {
          series.push({ name, data })
        }
      }

      extractSeries('max', this.$t('labels.maximum'))
      extractSeries('value', this.$t('labels.average'))
      extractSeries('min', this.$t('labels.minimum'))

      return series
    },
  },
}
</script>
